// extracted by mini-css-extract-plugin
export default {"columnContainer":"columnContainer__Uc5Gy","columnContainerBoutique":"columnContainerBoutique__S999T"};